import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { APP_NAME } from 'app/configs';
import { ScheduledEmailResponse } from 'app/models/EmailNotifications';

export type EmailNotificationStore = {
  notification: ScheduledEmailResponse | null
  setNotification: (notification: ScheduledEmailResponse) => void
  resetNotification: () => void
};

export const useEmailNotificationStore = create<EmailNotificationStore>()(
  persist(
    (set) => ({
      notification: null,
      setNotification: (notification) => set(() => ({
        notification,
      })),
      resetNotification: () => set(() => ({
        notification: null,
      })),
    }),
    {
      name: `${APP_NAME}-drive-storage`,
    },
  ),
);
